import { CPromotionContainer, CProductPromotion } from './styled'

export default {
    'promotion-container-app': CPromotionContainer,
    'promotion-product-app': CProductPromotion,
}